import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMainConfig, updateMainConfig } from '../../../../../../redux/stepsSlice';
import PersonalizationContentField from './PersonalizationContentField';

const SECTION = 'phc';
const HEADLINE = 'phcHeadline';
const SUBHEADER = 'phcSubHeaderDescription';

const readValue = (config, titleId) => {
  if (!Array.isArray(config)) return '';
  const section = config.find((s) => s.sectionId === SECTION);
  if (!section || !Array.isArray(section.values)) return '';
  const entry = section.values.find((v) => v.id === titleId);
  return entry && typeof entry.value === 'string' ? entry.value : '';
};

// BL-080 (Section 2) — path-header inspector: makes the headline and sub-header
// personalizable with the same token field as element content. Writes back into
// the existing `phc` design-config keys via updateMainConfig, so nothing new has
// to be persisted and the design wall stays in sync.
function PathHeaderInspector() {
  const dispatch = useDispatch();
  const mainConfig = useSelector((state) => getMainConfig(state));

  const hasPhc = Array.isArray(mainConfig) && mainConfig.some((s) => s.sectionId === SECTION);
  if (!hasPhc) return null;

  const set = (titleId) => (value) => dispatch(updateMainConfig({ sectionId: SECTION, titleId, value }));

  return (
    <div className="un-insp un-insp--header">
      <div className="un-isel">
        <span className="un-isel__cur">Path header</span>
      </div>
      <div className="un-insp__body">
        <PersonalizationContentField
          label="Headline"
          value={readValue(mainConfig, HEADLINE)}
          onChange={set(HEADLINE)}
        />
        <PersonalizationContentField
          label="Sub header description"
          value={readValue(mainConfig, SUBHEADER)}
          onChange={set(SUBHEADER)}
          minHeight={64}
        />
      </div>
    </div>
  );
}

export default PathHeaderInspector;
